
import Vue from 'vue'
import Vuex from 'vuex'

import { businessPremise } from '@/store/modules/businessPremise.module';
import { reservation } from '@/store/modules/reservation.module';
import { configuration } from '@/store/modules/configuration.module';
import { form } from '@/store/modules/form.module';

Vue.config.devtools = true
Vue.use(Vuex);

export default new Vuex.Store({

    modules: {
        businessPremise,
        reservation,
        configuration,
        form
    }

})
